var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconNodeEditEdge = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "1.5", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-410.417 -460.417)" },
                React.createElement("path", { d: "M411.8,469.2h2.2c0.7,0.1,1.2,0.7,1.1,1.4v9.7c0.1,0.7-0.4,1.3-1.1,1.4h-2.2" }),
                React.createElement("path", { d: "M439.1,469.2h-2.2c-0.7,0.1-1.2,0.7-1.1,1.4v9.7c-0.1,0.7,0.4,1.3,1.1,1.4h2.2" }),
                React.createElement("path", { d: "M420.8,475.2h-5.1" }),
                React.createElement("path", { d: "M433.4,475.2h-4.6" }),
                React.createElement("path", { d: "M428.2,475.4c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2\n\t\tC426.8,472.2,428.2,473.6,428.2,475.4L428.2,475.4z" }),
                React.createElement("path", { d: "M431.3,477.7l2.5-2.5l-2.5-2.5" })))));
});
export default IconNodeEditEdge;
//# sourceMappingURL=IconGraphEdge.js.map